<template>
  <div class="playlist-base" :class="{ 'has-tabhead': hasTabhead, 'has-filter': !!filterInfo}">
    <div class="playlist-header" :data-tag-id="tagId">
      <div class="title-area">
        <span class="return-btn" @click="onReturnClick">
          <img src="/static/img/common/header/back.svg">
        </span>
        <span class="title">{{ headTitle }}</span>
      </div>

      <see-later-button
        v-if="!isCategory
          && !isFeatures
          && tagId !== 'history'
          && tagId !== 'new'
          && tagId !== 'weekly_video'
          && !isFavlist
          && !!this.userProfile"
        :user-id="userProfile.id"
        :tag-id="tagId"
        :seelater-num="tagsSeelaterNum"
        :is-seelater="tagsIsSeelater"
      />

    </div>
    <div class="head-item">
      <div class="mess-area">
        <span>{{totalMessage}}</span>
        <filter-button
          v-if="!!filterInfo && !isFeatures"
          :filter-status="isFilterPanelOpen"
          @click.native.stop="onFilterBtnClick"
        />
      </div>
      <div class="tab-head" v-if="hasTabhead">
        <div class="tab-item" :class="{active: selected === 0}" @click="onTabItemClick(0, $event)">テキスト</div>
        <div class="tab-item" :class="{active: selected === 1}" @click="onTabItemClick(1, $event)">動画</div>
      </div>
    </div>

    <filter-panels
      v-if="!!filterInfo"
      :tag-id="tagIdMod"
      :user-id="userInfo.id"
      :access-token="accessToken"
      :filter-info="filterInfo"
      :panel-open="isFilterPanelOpen"
      :reset-trigger="filterResetTrigger"
      @close-panel="closeFilterPanel"
      @set-loading="setLoadingFlg"
    />

    <app-loading class="loginControllers__loading" :isLoading="loadingFlg"></app-loading>

    <div class="list-body" :class="{ 'has-tabhead': hasTabhead }" @scroll="onListScroll" v-if="!isError" ref="listbody">
      <div class="tab-body" v-for="(item, index) in selectedList" :key="index" :class="{active: selected === index}">
        <playlist-group
          :load-lock="loadLock"
          :target-list="item"
          :is-category="isCategory"
          :is-favlist="isFavlist"
          :category-id="categoryId"
          :user-profile="userProfile"
          :is-seelater-history="isSeelaterHistory"
          :has-tabhead="hasTabhead"
          :is-preview="isPreview"
          :show-feature-recommend="showFeatureRecommend && item.listType === 1"
          :feature-recommend-list="featuresRecommend"
          @open-item="openItem"
          @change-partner-click="onChangePartnerClick"
          @reset-trigger="resetTrigger"
          @has-closed-items="onHasClosedItems"
          @finish-closed-view="onFinishClosedView"
        />
        <div class="next-loader" v-if="loadLock"></div>
      </div>
    </div>

    <div class="error-message" :class="{ 'has-tabhead': hasTabhead }" v-if="isError">
      <img src="/static/img/icons/uranaitv_logo_lite.svg" />
      <span>{{ errMsg }}</span>
    </div>

    <detail-view
      :trigger="detailTrigger"
      :close-trigger="closeTrigger"
      :item-data="detailItem"
      :user-profile="userProfile"
      @close-complete="completeDetailClose"
      @change-partner-click="onChangePartnerClick"
    />

    <shortage-user-info
      :trigger="shortageTrigger"
      :close-trigger="shortageCloseTrigger"
      :shortage-list="shortageList"
      :user-info="userInfo"
      @loader-enable="loaderEnable"
      @update-info="shortageUpdateInfo"
      @close-complete="completeShortageUserInfoClose"
    />

    <change-partner-multiple
      :partner-list="updateUserData.friends"
      :trigger="changePartnerMultiTrigger"
      :close-trigger="changePartnerMultiCloseTrigger"
      @cancel-change="onReturnClick"
      @change-current="changeCurrentPartner"
      @close-complete="completeChangePertnerMultiClose"
      @to-detail="toPartnerDetail"
    />

    <change-partner
      :trigger="changePartnerTrigger"
      :close-trigger="changePartnerCloseTrigger"
      :required-list="requiredList"
      :partner-data="targetFriend"
      @loader-enable="loaderEnable"
      @update-info="changePartnerUpdateInfo"
      @close-complete="completeChangePertnerClose"
    />

    <playlist-modal
      v-if="showModal"
      @confirm="showModal = !showModal"
      @close="showModal = !showModal" >
      <p class="modalText">占う相手を変更しました。<br>相手の情報が必要なメニューを占い直しました。</p>
    </playlist-modal>

    <see-later-notice />

    <div class="dummy-for-popstate" />

    <!-- <floating-banner-base class="banner-base" :show-floating-banner="showFloatingBanner"> -->
      <!--
      <div class="features-recommend-base">
        <div class="recommend-wrap">
          <h4>こちらもおすすめ</h4>
          <a
            class="recommend-item"
            v-for="(rec, ridx) in featuresRecommend"
            :key="`frec${ridx}`"
            :href="rec.url"
            @click.prevent="onRecommendItemClick(rec)"
          >#{{rec.name}}</a>
        </div>
        <span class="close-btn" @click="onFeaturesRecommendCloseClick"><span></span></span>
      </div>
      -->

      <!--
      <div class="banner-body">
        <span class="button-link" @click="onSubscButtonClick"><span class="button-face">月額登録￥{{ subscPrice }}<span class="tax-in">（税込）</span></span></span>
      </div>
      -->
    <!-- </floating-banner-base> -->
  </div>
</template>

<script>
import { PLAYLIST_TYPE, ACQUIRED_MENUS_NUMBER, MENU_ITEM_TYPE } from '@/CONSTS/MENUS'
import * as type from '@/utvStore/store/mutation-types'
import {mapState} from 'vuex'
import moment from 'moment'
moment.locale('ja')

import PlaylistGroup from '@/utvStore/components/Playlist/PlaylistGroup'
import DetailView from '@/utvStore/components/partials/DetailView'
import ShortageUserInfo from '@/utvStore/components/partials/ShortageUserInfo'
import ChangePartner from '@/utvStore/components/partials/ChangePartner'
import PlaylistModal from '@/utvStore/components/common/PlaylistModal'
import IconBase from '@/utvStore/components/common/icon/IconBase.vue'
import ChangePartnerMultiple from '@/utvStore/components/partials/ChangePartnerMultiple'
import SeeLaterButton from '@/utvStore/components/partials/SeeLaterButton'
import SeeLaterNotice from '@/utvStore/components/partials/SeeLaterNotice'
import FloatingBannerBase from '@/utvStore/components/recommend/lp/partials/FloatingBannerBase'
import FilterPanels from '@/utvStore/components/Playlist/FilterPanels'
import FilterButton from '@/utvStore/components/Playlist/FilterButton'

/**
 * ///// 個別アクションの設定リスト //////
 * id: 対象のタグID
 * showCounts: 発火するカウント数の配列
 * banner: モーダルエリアに表示するHTML
 * click: エリアをクリックした際の処理
 */
const INDIVIDUAL_ACTIONS = [
  {
    id: 444,
    showCounts: [2],
    banner: '<img src="/static/img/banner/playlist_bnr_444_basecamp20221027.png" alt="暮れの酉ファンコミュニティサイト">',
    on: {
      bodyClick: () => {window.gtag('event', 'click', {
        'event_category': 'tag444-induction-button',
        'event_label': 'basecamp1'
      }); window.open('https://uranai-salon.jp/salons/13/detail?utm_source=uranaitv&utm_medium=banner&utm_campaign=kurenotori', '_blank')},
      closeClick: () => { //afterLeaveは処理のほうで投げてる
        window.gtag('event', 'close', {
          'event_category': 'tag444-induction-button',
          'event_label': 'basecamp1'
        })
      },
      onModalShow: () => {
        window.gtag('event', 'imp', {
          'event_category': 'tag444-induction-button',
          'event_label': 'basecamp1'
        })
      }
    }
  }
]
const INDIVIDUAL_ACTIONS_LSKEY = 'individual_actions_lskey'

export default {
  name: 'PlaylistBase',
  components: {
    DetailView,
    PlaylistGroup,
    ShortageUserInfo,
    ChangePartner,
    PlaylistModal,
    IconBase,
    ChangePartnerMultiple,
    SeeLaterButton,
    SeeLaterNotice,
    FloatingBannerBase,
    FilterPanels,
    FilterButton,
  },
  data() {
    return {
      lock: false,
      loadLock: false,
      allLock: false,
      thresholdRatio: 1.5,
      loadingFlg: false,
      isError: false,
      selected: 0,
      selectedList: [],
      selectedType: 0,
      selectedTotal: 0,
      detailTrigger: false,
      closeTrigger: false,
      detailItem: null,
      scrollCache: 0,
      hasTabhead: false,
      shortageTrigger: false,
      shortageCloseTrigger: false,
      shortageList: [],
      headTitle: '',
      beforeHeadTitle:'',
      totalMessage: '',
      requiredList:[],
      changePartnerTrigger: false,
      changePartnerResetFlg: false,
      changePartnerCloseTrigger: false,
      changePartnerItemId:'',
      showModal: false,
      targetFriend: {},
      changePartnerMultiTrigger: false,
      changePartnerMultiCloseTrigger: false,
      updateUserData:{},
      tagsSeelaterNum: 0,
      tagsIsSeelater: false,
      modalOpenState: 0,
      itemLenCache: 0,
      hasClosedList: false,
      showFloatingBanner: false,
      isFilterPanelOpen: false,
      filterResetTrigger: false,
      itemsLoadCount: 0,
      individualAction: null,
      individualModalOpen: false,
      individualActionCache: {},
      showFeatureRecommend: false,
      scrollData: {
        scroll: 0,
        openedElm: null,
      }
    }
  },
  props: {
    tagId: {
      type: String,
      default: ''
    },
    tagName: {
      type: String,
      default: ''
    },
    playlistData: {
      type: Object,
      default() {
        return {}
      }
    },
    tagsData: {
      type: Array,
      default() {
        return []
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    filterTagList: {
      type: [Object, Array],
      default() {
        return null
      }
    },
    isCategory: {
      type: Boolean,
      default: false
    },
    isFavlist: {
      type: Boolean,
      default: false
    },
    isSeelaterHistory: {
      type: Boolean,
      default: false
    },
    categoryId: {
      type: Number,
      default: 0
    },
    isSingle: {
      type: Boolean,
      default: false,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    subscUrl: {
      type: String,
      default: '/'
    },
    subscPrice: {
      type: Number,
      default: null,
    },
    isFeatures: {
      type: Boolean,
      default: false,
    },
    featuresRecommend: {
      type: Array,
      default() {
        return []
      }
    },
  },
  computed: {
    ...mapState({
      accessToken: states => states.auth.accessToken,
      subscrItemList: states => states.item.subscrItemList,
      tagInfo: states => states.item.tagInfo,
      subscriptVideoData: states => states.item.subscVideoItems,
      isChangePartnerReset: states => states.item.isChangePartnerReset,
      catpageReferrer: states => states.item.catpageReferrer,
      catpageHistory: states => states.item.catpageHistory,
      catpageReloadFlg: states => states.item.catpageReloadFlg,
      categoryItems: states => states.item.categoryItems,
      globalLock: states => states.uiState.globalLock,
      userInfo: states => states.account.user,
      isPc: state => state.uiState.isPc,
    }),
    playlistMod() {
      return this.subscrItemList.tabList
    },
    tagIdMod() {
      if(/^\w+$/.test(this.tagId)){ //念の為\w+で文字チェック
        return this.tagId
      }
      return ''
    },
    errMsg() {
      return this.isFavlist ? 'お気に入りしたコンテンツがありません' : '情報を取得できませんでした'
    },
    filterInfo() {
      return !!this.filterTagList
        && Object.keys(this.filterTagList).length > 0
        && Object.keys(this.filterTagList).every(item => Object.keys(item).length > 0)
        ? this.filterTagList : null
    },
    enableFeatureRecommend() {
      return this.isFeatures
    },
  },
  watch: {
    subscrItemList: {
      handler(){
        dbg.info('[watch] プレイリストAPIで取得した%O', this.subscrItemList)
        this.scrollData.openedElm = null
        if(!!this.subscrItemList && this.subscrItemList.length > 0) {
          this.setSelectedList(this.subscrItemList)
          if(this.isSingle){
            setTimeout(()=> {
              const tgtNum = this.subscrItemList[0].itemList.length > 0 ? 0 : 1 // 対象リスト判定
              this.onTabItemClick(tgtNum, true)
              this.openItem(this.subscrItemList[tgtNum].itemList[0].id)
            },100)
          }
        }
      },
      deep: true
    },
    tagInfo: {
      handler(){
        this.tagsSeelaterNum = this.tagInfo.seelaterNum
        this.tagsIsSeelater = this.tagInfo.isSeelater
      },
      deep: true
    },
    changePartnerMultiTrigger(n){
      if(n) this.beforeHeadTitle = this.headTitle
      this.headTitle = n ? '相手を変更して占う': this.beforeHeadTitle
      if(!this.isPc) document.querySelector('.footer').style.display = (n && !this.changePartnerTrigger) ? 'none' : 'inline'
      const seelater = document.querySelector('.seelater')
      if(seelater) seelater.style.display = n ? 'none' : 'flex'
    },
    changePartnerTrigger(n){
      this.headTitle = n && !this.targetFriend ? '相手を追加': '相手を変更して占う'
      if(!this.isPc) document.querySelector('.footer').style.display = n ? 'inline' : 'none'
    },
    userInfo:{
      handler(n){
        this.updateUserData = Object.assign({}, n)
      },
      deep:true
    },
    categoryItems: {
      handler(){
        // カテゴリ表示更新
        const pastlist = [...this.selectedList[0].itemList]
        const newlist = this.categoryItems
        let modlist = [...newlist]
        if(this.isSeelaterHistory) {
          for (let [idx, item] of pastlist.entries()) {
            let tgt = 0, offset = 1, flg = false, candidx = 0, candidate = null
            for (let chk of newlist) {
              if (+item.id === +chk.id) {
                tgt = +item.id
                break
              }
            }
            if (tgt === 0) {
              do {
                candidx = idx + (!flg ? -1 : 1) * offset
                candidate = {...pastlist[candidx]}
                if (!!candidate) {
                  for(let [chkidx, chk] of modlist.entries()){
                    if(candidate.id === chk.id) {
                      item.is_seelater = false
                      item.seelater_num = item.seelater_num < 1 ? 0 : item.seelater_num - 1
                      modlist.splice(chkidx + (flg ? 0 : 1), 0, {...item})
                      tgt = 999999
                      break
                    }
                  }
                  if(tgt === 0){
                    offset += flg ? 1 : 0
                    flg = !flg
                  }
                } else {
                  offset += flg ? 1 : 0
                  flg = !flg
                }
              } while (tgt === 0 && (candidx >= 0 || candidx < pastlist.length) &&  offset < pastlist.length)
              if(tgt === 0){ //処理終わってまだ0なら
                item.is_seelater = false
                item.seelater_num = item.seelater_num < 1 ? 0 : item.seelater_num - 1
                modlist.push({...item})
              }
            }
          }
        }
        this.selectedList.splice(0)
        this.selected = 0
        this.selectedList.push({
          listType: PLAYLIST_TYPE.text,
          totalLen: modlist.length,
          itemList: []
        })
        for(let item of modlist){
          this.selectedList[0].itemList.push({...item, name: item.tag_name})
        }
      },
      deep: true
    }
  },
  created(){
    //個別アクションの設定(20221027ベースキャンプ送客用に実装)
    const ia = INDIVIDUAL_ACTIONS.find(item => item.id === +this.tagId)
    if(ia) this.individualAction = ia
    // ----> end

    this.$store.dispatch(type.RESET_TAGITEMS_FILTER)
    this.$store.dispatch(type.SET_TEXT_DETAIL_OPEN)
    if( !!this.userProfile && this.userProfile.subscription && !this.isPreview) {
      const subsc = this.userProfile.subscription
      if (subsc.status === 2) {
        // location.href = '/error/suspension'
      } else {
        if (this.isCategory) {
          // カテゴリ表示初期処理
          this.selectedList.splice(0)
          this.selected = 0
          this.selectedList[0] = {
            listType: PLAYLIST_TYPE.text,
            totalLen: this.tagsData.length,
            itemList: []
          }
          for (let item of this.tagsData) {
            this.selectedList[0].itemList.push({...item, name: item.tag_name})
          }
        } else {
          // 通常表示初期処理
          this.loadingFlg = true
          this.loadLock = true

          //動画タブを開くか判定
          if (!!location.search && parseInt(location.search.match(/movies=(.+)/)[1]) === 1) {
            this.selected = 1
          }

          //お気に入り履歴ページか判定
          if (this.isFavlist) {
            this.$store.dispatch(type.GET_FAV_HISTORY, {userId: this.userInfo.id, accToken: this.accessToken})
          } else {
            if (this.isSingle) {
              this.$store.dispatch(type.SET_RETURN_TABLIST, {
                tablist: this.playlistData.tabList,
              })
            } else {
              this.$store.dispatch(type.GET_NEXT_TAG_ITEMS, {
                userId: this.userInfo.id,
                tagId: this.tagIdMod,
                accToken: this.accessToken
              })
            }
          }
        }
      }
    } else if(this.isPreview){
      this.$store.dispatch(type.SET_RETURN_TABLIST, {
        tablist: this.playlistData.tabList,
        isPreview: true,
      })
    } else {
      console.error('Error: リストの表示ができません')
      // location.href = '/error/suspension'
    }
  },
  mounted() {
    dbg.info('[userProfile from blade]:%O', this.userProfile)
    dbg.info('[tagsData from blade]:%O', this.tagsData)
    dbg.info('[filterTagList from blade]:%O', this.filterTagList)
    dbg.info('[features(%s)] from blade]: recommend %O', this.isFeatures, this.featuresRecommend)

    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.width = '100%'
    document.body.style.height = '100%'
    document.querySelector('header').style.boxShadow = 'none'
    window.addEventListener('popstate', this.onPopstate)

    const num = !!this.selectedList[this.selected] ? this.selectedList[this.selected].totalLen : 0

    this.$store.dispatch(type.SET_CLOSED_ITEMS_TOKEN)

    if(this.isCategory){
      window.addEventListener('pageshow', this.onCategoryPageshow)
      if(this.isSeelaterHistory) { // ※カテゴリ属性は生かす
        this.headTitle = 'あとで見る'
        this.totalMessage = `${num}個のプレイリスト`
      }else {
        // const res = location.pathname.match(/^\/category\/(\w+)\/?/)
        // this.categoryId = res[1]
        switch (this.categoryId) {
          case 3:
            this.headTitle = '占い師でさがす'
            this.totalMessage = `${num}名の占い師`
            break
          case 4:
            this.headTitle = '占い方でさがす'
            this.totalMessage = `${num}個の占い方`
            break
          case 5:
            this.headTitle = 'カテゴリーでさがす'
            this.totalMessage = `${num}個のカテゴリー`
            break
          case 6:
            this.headTitle = '今週のランキング'
            this.totalMessage = `${num}個のカテゴリー`
            break
          default:
        }
      }
    }else {
      this.headTitle = this.isFavlist ? 'お気に入り' : this.tagName // お気に入りの場合はタイトル変更
      this.totalMessage = `${num}本の${this.selectedType === 0 ? 'テキスト' : '動画' }`
    }
    // this.checkBannerShow()
    this.checkRecommendShow()
    this.getIndividualAntionCache()
  },
  methods: {
    loaderEnable() {
      this.loadingFlg = true
    },
    onFinishClosedView(){
      this.hasClosedList = false
    },
    onHasClosedItems(){
      this.hasClosedList = true
    },
    onTabItemClick(id, force = false) {
      // console.log('loadLock[%s] selected[%s] id[%s]', this.loadLock, this.selected, id)
      if((!this.loadLock && this.selected !== id) || force){
        this.selected = id
        this.selectedType = !!this.selectedList[this.selected] ? (this.selectedList[this.selected].listType === 2 ? 1 : 0 ): 0
      }
      this.totalMessage = `${this.selectedList[this.selected].totalLen}本の${this.selectedType === 0 ? 'テキスト' : '動画' }`
    },
    onCategoryPageshow(){
      if(this.isSeelaterHistory){
        this.$store.dispatch(type.GET_SEELATER_ITEMS, {
          accToken: this.accessToken
        })
      }else if(this.isCategory){
        this.$store.dispatch(type.GET_CATEGORY_ITEMS, {
          accToken: this.accessToken,
          categoryId: this.categoryId
        })
      }
    },
    setSelectedList(tgtList){
      if ('error' in tgtList[0]) {
        this.isError = true
      } else {
        this.selectedList = [...tgtList]
        this.selectedType = this.selectedList[this.selected].listType === 2 ? 1 : 0
        this.totalMessage = `${this.selectedList[this.selected].totalLen}本の${this.selectedType === 0 ? 'テキスト' : '動画'}`

        //相手を変えて占うの場合の処理
        if(this.isChangePartnerReset) {
          this.$store.dispatch(type.SET_CHANGE_PARTNER_RESET, false)
          this.changePartnerResetFlg = true
          if(this.changePartnerMultiTrigger) this.changePartnerMultiCloseTrigger = true
          this.closeTrigger = true
        }

        // 詳細を開いているときは詳細情報のお気に入り数を更新
        if (!!this.detailItem && this.detailTrigger) {
          const chklist = this.selectedList[this.selected].itemList
          if (!!chklist && chklist.length > 0) {
            for (let item of chklist) {
              if (+item.id === +this.detailItem.id) {
                this.detailItem.localFavNum = item.localFavNum
                this.detailItem.localFavStat = item.localFavStat
                break
              }
            }
          }
        }
      }
      if (this.shortageTrigger) {
        this.shortageCloseTrigger = true
      }

      // ２つめのタブリスト（動画の方）が空だったらタブは表示しない
      this.hasTabhead = (tgtList.length > 1 && !((!!tgtList[1] && tgtList[1].itemList.length === 0) || tgtList[0].itemList.length === 0))
        || this.tagId === 'history'
        || this.isFavlist


      /*
      this.hasTabhead = (!!tgtList[1] && !!tgtList[1].itemList && tgtList[1].itemList.length > 0)
        || this.tagId === 'history'
        || this.isFavlist
       */


      //特集ページの時のみレコメンド表示チェック
      if(this.isFeatures) {
        this.showFeatureRecommend = +this.selectedList[0].totalLen <= this.selectedList[0].itemList.length
      }

      setTimeout(()=>{
        this.loadLock = false
        this.loadingFlg = false
      }, 1000)
    },
    onChangePartnerClick(id){
      history.pushState(null, null, null)
      this.modalOpenState = 2
      this.changePartnerItemId = id
      this.changePartnerMultiTrigger = true
    },
    toPartnerDetail(friendId){
      history.pushState(null, null, null)
      this.modalOpenState = 2
      if(friendId) this.targetFriend = this.updateUserData.friends.find((v)=>v.friend_id === friendId)
      else this.targetFriend = null
      this.changePartnerTrigger = true
    },
    onPopstate() {
      if(this.isCategory){
        history.pushState(null, null, null)
        this.onReturnClick(true)
        return
      }else{
        if(this.modalOpenState === 2) {
          this.modalOpenState = 1
          this.onReturnClick(true)
        }
      }
    },
    onReturnClick(fromPopstate = false) {
      this.allLock = false
      if(!this.globalLock) {
        if(this.modalOpenState === 2) {
          history.go(-1)
        }else{
          if (this.detailTrigger) {
            this.modalOpenState = 0
            this.closeTrigger = true
          } else if(this.changePartnerTrigger){
            this.changePartnerCloseTrigger = true
            this.modalOpenState = 2
          } else if (this.changePartnerMultiTrigger) {
            this.changePartnerMultiCloseTrigger = true
          } else if (this.shortageTrigger) {
            this.modalOpenState = 0
            this.shortageCloseTrigger = true
          } else if (this.isCategory && this.catpageReferrer != null && this.catpageReferrer.length > 0){
            this.$store.dispatch(type.SET_CATPAGE_REFERRER, '')
            //location.href = this.catpageReferrer
            history.back()
          } else {
            if(/\/category\//.test(document.referrer)
              || /\/history\/later/.test(document.referrer)
            ){
              //location.href = document.referrer
              history.back()
            } else {
              history.back()
            }
          }
        }
      }
    },
    resetTrigger(){
      this.lock = false
      this.allLock = false
      this.detailTrigger = false
      this.closeTrigger = false
      this.$store.dispatch(type.GLOBAL_LOCK, false)
    },

    openItem( menuData ) {
      const tgtList = this.selectedList[this.selected]
      const menuId = menuData.id
      const elm = menuData.elm

      //ターゲットエレメント追加
      this.scrollData.openedElm = elm

      if(!this.isPreview) {
        for (let item of tgtList.itemList) {
          if (item.id === menuId) {
            if (this.isCategory) {
              this.$store.dispatch(type.SET_CATPAGE_REFERRER, document.referrer)
              location.href = `/tag/${item.id}`
            } else {
              // this.scrollCache = window.pageYOffset
              // document.body.style.overflow = 'hidden'
              // document.body.style.position = 'fixed'
              // document.body.style.width = '100%'

              this.detailItem = {...item, listType: this.selectedType}
              this.lock = true
              this.requiredList = item.required

              //ビデオの場合、detailItemにビデオ情報を詰める
              if (item.itemType === MENU_ITEM_TYPE.movie) {
                const videoDataOneList = this.subscriptVideoData.filter((data) => {
                  return data.subscript_store_product_id == item.videoId
                })
                const videoData = videoDataOneList.length > 0 ? videoDataOneList[0] : {}
                this.detailItem = {...item, videoData}
              }

              if (!!this.detailItem && !!this.detailItem.info && this.detailItem.info.length > 0) {
                this.allLock = true
                dbg.info('[不足情報]:%O', this.detailItem.info)
                this.shortageList.splice(0)
                this.shortageList = []
                this.shortageList.push({})
                for (let inf of this.detailItem.info) {
                  for (let key in inf) {
                    this.shortageList[0][key] = inf[key]
                  }
                }
                history.pushState(null, null, null)
                this.modalOpenState = 2
                this.shortageTrigger = true
                this.shortageCloseTrigger = false
              } else {
                if (this.detailItem.itemType === MENU_ITEM_TYPE.text) {
                  //テキストアイテムの場合は詳細を開かない
                  this.$store.dispatch(type.SET_TEXT_DETAIL_OPEN, +this.detailItem.id)
                } else {
                  history.pushState(null, null, null)
                  this.modalOpenState = 2
                  this.allLock = true
                  this.detailTrigger = true
                  this.closeTrigger = false
                }
                this.$store.dispatch('SET_TAG_ITEM_HISTORY', {menuId: menuId, accToken: this.accessToken})
              }
            }
            return
          }
        }
      }else{
        window.gtag('event', 'click', {
          'event_category': `Freeplaylist-subsc-list`,
          'event_label': menuId
        })
        location.href = this.subscUrl
        return
      }
      console.error('Error: メニューデータが存在しません')
    },

    onListScroll(e){
      if(!this.loadLock
        && !this.hasClosedList
        && !!this.userProfile
        && !this.isPreview
        && !this.individualModalOpen
      ) {
        const tgtHeight = this.$el.querySelector('.tab-body.active').clientHeight
        /*
        console.log('  - スクロール判定%s/%s [ %s ] tabH:%s viewH:%s',
          e.target.scrollTop,
          tgtHeight - e.target.clientHeight * this.thresholdRatio,
          e.target.scrollTop > tgtHeight - e.target.clientHeight * this.thresholdRatio,
          tgtHeight,
          e.target.clientHeight
        )
         */
        const scr = e.target.scrollTop
        this.scrollData.scroll = scr

        //開いたアイテムが画面外に出たかチェック
        if(!!this.scrollData.openedElm) {
          const el = this.scrollData.openedElm
          const upp = el.getBoundingClientRect().top + scr
          const lwr = el.getBoundingClientRect().bottom + scr
          if(lwr < scr || scr + window.innerHeight < upp) this.scrollData.openedElm = null
        }


        //スクロールチェック
        if(scr > tgtHeight - e.target.clientHeight * this.thresholdRatio){
          const tgtList = this.selectedList[this.selected]
          // console.log('  データ取得できるねぇitemListLen[%s] total[%s] cache[%s]', tgtList.itemList.length, tgtList.totalLen, this.itemLenCache)
          if(tgtList.itemList.length < tgtList.totalLen && tgtList.itemList.length !== this.itemLenCache) {
            this.itemsLoadCount++
            // dbg.info('>>> データ取得する itemsLoadCount[%s] selectedList:%O', this.itemsLoadCount, this.selectedList )
            this.checkIndividualActionEnable()
            this.loadLock = true
            this.itemLenCache = tgtList.itemList.length
            this.$store.dispatch(type.GET_NEXT_TAG_ITEMS, {userId: this.userInfo.id, tagId: this.tagIdMod, accToken: this.accessToken})
          }
        }
      }
      // this.checkBannerShow()
      this.checkRecommendShow()
    },
    getIndividualAntionCache() {
      // 個別処理用のキャッシュを取得
      const ialsdatastr = localStorage.getItem(INDIVIDUAL_ACTIONS_LSKEY)
      if(!!ialsdatastr && ialsdatastr.length > 0) this.individualActionCache = JSON.parse(ialsdatastr)
    },
    setIndividualActionCache(data){
      const now = this.$nowTime.now
      if( !( `tag${data.tagId}` in this.individualActionCache ) ) {
        this.individualActionCache[`tag${data.tagId}`] = {}
      }
      this.individualActionCache[`tag${data.tagId}`][`cnt${this.itemsLoadCount}`] = now.endOf('day').format()
      localStorage.setItem(INDIVIDUAL_ACTIONS_LSKEY, JSON.stringify(this.individualActionCache))
      this.individualModalOpen = false
    },
    checkIndividualActionEnable(){
      const now = this.$nowTime.now
      if(this.individualAction){
        if(
          !(!!this.individualActionCache
            && `tag${this.tagId}` in this.individualActionCache
            && !!this.individualActionCache[`tag${this.tagId}`][`cnt${this.itemsLoadCount}`]
            && now.isSameOrBefore(this.individualActionCache[`tag${this.tagId}`][`cnt${this.itemsLoadCount}`])
          )
          && this.individualAction.showCounts.some(item => item === this.itemsLoadCount)
        ){
          this.individualModalOpen = true
          this.$store.dispatch(type.OPEN_BASIC_MODAL, {
            dialogBody: this.individualAction.banner,
            enableBgClick: true,
            addionalData: {
              tagId: this.tagId,
              loadCount: this.itemsLoadCount,
            },
            on: {
              ...this.individualAction.on,
              afterLeave: data => this.setIndividualActionCache(data)
            }
          })
        }
      }
    },
    shortageUpdateInfo(){
      this.changePartnerResetFlg = false
      this.$store.dispatch(type.RESET_TAG_ITEMS)
        .then(()=>{
          history.back()
          if(this.isFavlist) {
            this.$store.dispatch(type.SET_CHANGE_PARTNER_RESET, true)
            this.$store.dispatch(type.GET_FAV_HISTORY, {userId: this.userInfo.id, accToken: this.accessToken})
          }else {
            if(this.isSingle){
              location.reload()
            }else{
              this.$store.dispatch(type.GET_TAG_ITEMS_ALL, {
                userId: this.userInfo.id,
                tagId: this.tagIdMod,
                accToken: this.accessToken,
                resetItems: true,
                isChangePartnerReset: true
              })
            }
          }
        })
    },
    changeCurrentPartner(){
      this.changePartnerResetFlg = false
      this.$store.dispatch(type.RESET_TAG_ITEMS)
        .then(()=>{
          this.modalOpenState = 2
          if(this.isFavlist) {
            this.$store.dispatch(type.SET_CHANGE_PARTNER_RESET, true)
            this.$store.dispatch(type.GET_FAV_HISTORY, {userId: this.userInfo.id, accToken: this.accessToken})
          }else {
            history.back()
            if(this.isSingle){
              location.reload()
            }else {
              this.$store.dispatch(type.GET_TAG_ITEMS_ALL, {
                userId: this.userInfo.id,
                tagId: this.tagIdMod,
                accToken: this.accessToken,
                resetItems: true,
                isChangePartnerReset: true
              })
            }
          }
        })
    },
    changePartnerUpdateInfo(){
      this.modalOpenState = 2
      this.$store.dispatch(type.GET_ACCOUNT, this.accessToken).then((res)=>{
        this.updateUserData = Object.assign({}, res)
      })
      this.loadingFlg = false
      history.back()
      this.completeChangePertnerClose()
    },
    completeDetailClose(){
      // document.body.style.overflowX = 'hidden'
      // document.body.style.overflowY = 'auto'
      // document.body.style.position = 'static'
      // document.body.style.width = 'auto'
      // setTimeout(()=>{
        // window.scroll({ top: this.scrollCache } )
      // }, 100)
      if(this.changePartnerResetFlg){
        //this.changePartnerResetFlg = false
        this.changePartnerCloseTrigger = true
      }else{
        this.resetTrigger()
      }
    },
    completeShortageUserInfoClose(){
      if(this.changePartnerResetFlg) {
        this.changePartnerResetFlg = false
        this.$el.querySelector('.list-body').scrollTo({top})
      }
      this.modalOpenState = 2
      this.shortageTrigger = false
      this.shortageCloseTrigger = false
      this.lock = false
      this.allLock = false
      this.$store.dispatch(type.GLOBAL_LOCK, false)
    },
    completeChangePertnerMultiClose(){
      if(this.changePartnerResetFlg) {
        this.showModal = true
        //this.changePartnerResetFlg = false
        this.detailTrigger = false
      }
      this.changePartnerMultiTrigger = false
      this.changePartnerMultiCloseTrigger = false
      this.completeShortageUserInfoClose()
    },
    completeChangePertnerClose(){
      this.changePartnerTrigger = false
      this.changePartnerCloseTrigger = false
      this.completeShortageUserInfoClose()
    },

    /*
    // 2022/4 UranaiTV施策にて入れているが現状使ってない
    checkBannerShow(){
      const topOffset = 50
      const bottomOffset = 100
      const tgt = this.$refs.listbody
      const pg = tgt.childNodes[0]
      const sc = tgt.scrollTop
      const ih = window.innerHeight
      this.showFloatingBanner = this.isPreview && sc > topOffset && sc < pg.clientHeight - ih - bottomOffset
    },
     */
    checkRecommendShow(){
      const bottomOffset = 100
      const tgt = this.$refs.listbody
      const pg = tgt.childNodes[0]
      const sc = tgt.scrollTop
      const ih = window.innerHeight
      const topOffset = window.innerHeight / 2
      this.showFloatingBanner = this.enableFeatureRecommend
        && this.isFeatures
        && !this.scrollData.openedElm
        && !!tgt && !!pg && sc > topOffset &&  sc < pg.clientHeight - ih - bottomOffset
    },
    onSubscButtonClick(){
      window.gtag('event', 'click', {
        'event_category': 'Freeplaylist-floating-subsc-button',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    onFilterBtnClick(){
      this.isFilterPanelOpen = !this.isFilterPanelOpen
      this.filterResetTrigger = !this.isFilterPanelOpen
    },
    closeFilterPanel(){
      this.isFilterPanelOpen = false
    },
    setLoadingFlg(){
      this.loadLock = true
      this.loadingFlg = true
    },
    /*
    onRecommendItemClick(item) {
      location.href = item.url
    },
    onFeaturesRecommendCloseClick() {
      // this.enableFeatureRecommend = false
      this.checkRecommendShow()
    },
     */
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.playlist-base {
  $headH: 44px;
  $messH: 35px;
  $messH_L: 48px;
  $tabHeadH: 38px;
  padding-top: $messH;
  padding-bottom: 50px;
  width: 100%;
  max-width: 580px;
  margin: auto;
  overflow: hidden;
  &.has-tabhead {
    padding-top: $messH + $tabHeadH;
  }

  .playlist-header {
    width: 100%;
    height: $headH;
    background: $col_def_gradient;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 90001;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-area{
      display: flex;
      align-items: center;
      .return-btn {
        display: inline-block;
        margin-right: 12px;
        img {
          vertical-align: top;
        }
      }
      .title {
        display: inline-block;
        color: $col_white;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .seelater{
      display: flex;
      align-items: center;
      .num{
        margin-left: 4px;
        font-size: 11px;
        color: $col_white
      }
    }
  }
  .head-item {
    position: fixed;
    top: $headH;
    max-width: 580px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    .mess-area {
      font-weight: normal;
      font-size: 12px;
      line-height: 1;
      padding: 0 20px;
      color: $col_base_font;
      height: $messH;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;
      background: rgba(255,255,255,0.7);
      box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
    }
    .tab-head {
      width: 100%;
      padding: 0 20px;
      display: flex;
      border-bottom: 2px solid $col_temp_gray3;
      margin: auto;
      max-width: 580px;
      .tab-item {
        padding: 12px 0;
        margin-bottom: -2px;
        font-weight: bold;
        font-size: 14px;
        line-height: 1;
        text-align: center;
        color: $col_temp_gray5;
        cursor: pointer;
        width: 50%;
        &.active {
          color: $col_temp_key1;
          position: relative;
          cursor: default;
          &::after {
            content: "";
            width: 100%;
            height: 2px;
            background: $col_def_gradient;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            display: block;
            position: absolute;
          }
        }
      }
    }
  }
  .list-body {
    position: fixed;
    top: $headH + $messH;
    bottom: 50px;
    width: 100%;
    max-width: 580px;
    overflow-x: hidden;
    overflow-y: auto;
    @include mq('pc') {
      bottom: 0;
    }
    &.has-tabhead {
      top: $headH + $messH + $tabHeadH;
    }
    .tab-body {
      width: 100%;
      display: none;
      //padding-bottom: 8px;
      &.active {
        display: block;
      }
    }
  }
  /deep/ .filter-panel-base {
    top: $headH + $messH;
  }

  &.has-filter {
    padding-top: $messH_L;
    &.has-tabhead {
      padding-top: $messH_L + $tabHeadH;
    }
    .head-item {
      .mess-area {
        height: $messH_L;
      }
    }
    .list-body {
      top: $headH + $messH_L;
      &.has-tabhead {
        top: $headH + $messH_L + $tabHeadH;
      }
    }
    /deep/ .filter-panel-base {
      top: $headH + $messH_L;
    }
  }
}
.loginControllers__loading {
  position: fixed;
  z-index: 3;
  top: 45vh;
  left: 0;
  right: 0;
  margin: auto;
}
.error-message {
  position: fixed;
  top: 79px;
  bottom: 50px;
  width: 100%;
  max-width: 580px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 13px;
  line-height: 19px;
  color: $col_temp_gray5;
  &.has-tabhead {
    top: 117px;
  }
  img {
    display: block;
    margin-bottom: 8px;
  }
}
.next-loader {
  width: 100%;
  height: 60px;
  background: url('/static/img/common/loading.svg') no-repeat center center;
  background-size: 60px 60px;
}
.modalText{
  margin: 0 0 40px;
  font-size: 13px;
}


.banner-body {
  background: rgba(255, 255, 255, 0.8);
  padding: 24px 24px 8px;
  width: 100%;
  height: 100%;
  .button-link {
    min-width: 270px;
    max-width: 400px;
    margin: 0 auto;
    font-weight: bold;
    font-size: 16px;
    color: white;
    min-height: 55px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 100px;
    cursor: pointer;
    position:relative;
    background: $col_def_gradient;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    user-select: none;
    &::before {
      position:absolute;
      top:0;
      left:0;
      z-index:-1;
      box-sizing:border-box;
      border-radius:100px;
      padding:2px;
      width:100%;
      height:100%;
      background:#fff;
      background-clip:content-box;
      content:"";
    }
    .button-face {
      color: $col_temp_key1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: 'Hiragino Kaku Gothic Pro', 'source-han-sans-japanese', -apple-system, BlinkMacSystemFont, sans-serif;
      .tax-in {
        display: inline-block;
        margin: 0 -0.5em;
      }
      /deep/ {
        .notice,
        .face-body{
          display: block;
          width: 100%;
          color: $col_temp_key1;
          //グラデ方向崩れるため個別指定
          background: $col_def_gradient;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .notice {
          font-size: 0.8em;
          line-height: 1;
        }
      }
    }
    &.disable {
      pointer-events: none;
      background: #dcdfe2;
      .button-face {
        color: #dcdfe2;
        background: none;
        -webkit-text-fill-color: initial;
        -webkit-background-clip: border-box;
      }
    }
  }
}

/deep/ {
  .floating-banner {
    //height: 100px;
    //overflow: hidden;
    bottom: 50px !important;
    @include mq('w580') {
      bottom: 0 !important;
    }
  }
}

.features-recommend-base {
  width: 100%;
  background: rgba(255,255,255,0.95);
  box-shadow: 0px -2px 8px rgba(218, 218, 218, 0.4);
  position: relative;

  .close-btn {
    display: block;
    width: 30px;
    height: 30px;
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    & > span {
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
      &::before,
      &::after {
        content: "";
        display: block;
        background: #656d78;
        height: 2px;
        border-radius: 2px;
        width: 28px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      &::before {
        transform: rotate(-45deg);
      }
      &::after {
        transform: rotate(45deg);
      }
    }
  }

  .recommend-wrap {
    h4 {
      color: #32373f;
      font-size: 16px;
      margin: 0 0 16px;
    }
    width: 100%;
    max-width: 580px;
    padding: 16px 20px 4px;
    margin: auto;
    a {
      display: block;
      color: #ff7497;
      font-size: 15px;
      cursor: pointer;
      margin: 0 0 18px;
      text-decoration: none;
      line-height: 1;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Playlist/PlaylistBase.vue